import EmptyListMessage from '@components/common/EmptyListMessage';
import SingleBanner from '@components/common/SingleBanner';
import WishlistProduct from '@moncler/components/wishlist/WishlistProduct';
import analytics from '@utils/analytics';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useBreakpoint from '@utils/useBreakpoint';
const WishlistContent = (props) => {
    const { banners } = props;
    const [wishlist, setWishlist] = useState(props.wishlist.items);
    const [deleted, setDeleted] = useState(null);
    const [changed, setChanged] = useState('');
    const { t } = useTranslation();
    const itemsContainer = useRef(null);
    const currentBreakpoint = useBreakpoint();
    const removeDuplicateTimer = useRef();
    useEffect(() => {
        setWishlist(props.wishlist.items);
    }, [props.wishlist.items]);
    useEffect(() => {
        if (itemsContainer.current) {
            let row = 0;
            let lastOffset = 0;
            Array.from(itemsContainer.current.children).forEach((el, i) => {
                const element = el;
                if (lastOffset && element.offsetTop !== lastOffset) {
                    row++;
                }
                element.dataset.row = row.toString();
                lastOffset = element.offsetTop;
            });
            for (let i = 0; i <= row; i++) {
                const rowSiblings = Array.from(document.querySelectorAll(`[data-row="${i}"]`));
                const infoMaxHeight = rowSiblings.reduce((prev, next) => {
                    const title = next.querySelector('.wishlist__single-product__product-info__container');
                    title.style.removeProperty('--siblings-height');
                    return Math.max(title.offsetHeight, prev);
                }, 0);
                rowSiblings.forEach((el) => {
                    el.querySelector('.wishlist__single-product__product-info__container').style.setProperty('--siblings-height', infoMaxHeight.toString() + 'px');
                });
            }
        }
    }, [wishlist, currentBreakpoint]);
    const messageForEmptyListing = (React.createElement(React.Fragment, null,
        React.createElement(EmptyListMessage, { buttonLink: window.homeurl, buttonText: t('button.backtoshopping'), text: t('wishlist.emptylist'), pushAnalytics: () => analytics.savedForLaterThree() }),
        React.createElement("div", { className: "wishlist__banner-wrapper" }, banners === null || banners === void 0 ? void 0 : banners.map((banner) => {
            var _a;
            return (React.createElement(SingleBanner, { key: banner.ID, aspectRatio: "aspect-ratio--3-2", title: banner.title, buttonText: banner.linkText, buttonLink: banner.link, backgroundImage: (_a = banner === null || banner === void 0 ? void 0 : banner.bg_image) === null || _a === void 0 ? void 0 : _a.path }));
        }))));
    return (React.createElement("div", { className: "wishlist-wrapper" }, (wishlist === null || wishlist === void 0 ? void 0 : wishlist.length) > 0 ? (React.createElement("ul", { className: "wishlist__products-listing", ref: itemsContainer }, wishlist.map((wishlistitem, i) => (React.createElement(WishlistProduct, { key: wishlistitem.isMbm ? wishlistitem.pid + wishlistitem.mbm.recipeId : wishlistitem.isGiftCard ? wishlistitem.UUID : wishlistitem.pid, type: wishlistitem.isMbm ? 'mbm' : 'products', removeFunction: props.removeProduct, updateFunction: (oldProduct, newProductId, recipeId, callback) => {
            removeDuplicateTimer.current && clearTimeout(removeDuplicateTimer.current);
            props.updateProduct(oldProduct, newProductId, recipeId, callback);
            removeDuplicateTimer.current = setTimeout(() => {
                setWishlist(wishlist.filter((prod) => prod.pid != newProductId || prod === wishlistitem));
            }, 1000);
        }, updateWishLists: props.updateWishLists, updateGiftCard: props.updateGiftCard, product: wishlistitem, inPublicWishlist: props.inPublicWishlist, shareenabled: props.shareenabled, shareformdef: props.shareformdef, wishlist: props.wishlist, toDelete: deleted && deleted.pid == wishlistitem.pid }))))) : props.type == 'mbm' ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: 'col-md-6 offset-md-3' },
                React.createElement("p", { className: "empty-wishlist-mbm" }, window.loggedin ? t('wishlist.mbmemptylogged') : t('wishlist.mbmemptyguest'))), banners === null || banners === void 0 ? void 0 :
            banners.map((banner) => {
                var _a;
                return (React.createElement("div", { key: banner.ID, className: 'col-md-6 offset-md-3' },
                    React.createElement(SingleBanner, { aspectRatio: "aspect-ratio--3-2", title: banner.title, buttonText: banner.linkText, buttonLink: banner.link, backgroundImage: (_a = banner === null || banner === void 0 ? void 0 : banner.bg_image) === null || _a === void 0 ? void 0 : _a.path, mbm: true })));
            })))) : (messageForEmptyListing)));
};
export default WishlistContent;
